import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import axiosPrivate from 'config/axiosPrivate';
import { UserSessionSelector } from 'store/UserSession';
import { ROLES } from 'utils/Constants';

/**
 * Hook pour gérer l'auto-sauvegarde des textes AdminClient
 * Utilise l'endpoint /texts/external/auto-save/{id}
 */
export const useAdminClientAutoSave = ({ textId }) => {
  const { user } = useSelector(UserSessionSelector);

  const autoSave = useCallback(
    async (
      textContent,
      htmlContent,
      redactionData,
      initialHtmlContent,
      initialTextContent,
      type,
      url,
      titleTag,
      metaDescriptionTag,
      contentScore
    ) => {
      const isConsultant =
        user?.role === ROLES.CONSULTANT ||
        (typeof window !== 'undefined' &&
          window.location?.pathname?.startsWith('/Consultant'));

      if (isConsultant) {
        return;
      }

      if (!textId && !redactionData?.id) {
        return;
      }

      const currentTextId = textId || redactionData?.id;

      try {
        const payload = {
          url: url ?? redactionData?.url ?? '',
          titleTag: titleTag ?? redactionData?.titleTag ?? '',
          metaDescriptionTag: metaDescriptionTag ?? redactionData?.metaDescriptionTag ?? '',
          actualTextContent: textContent || '',
          initialTextContent: initialTextContent || '',
          actualHtmlContent: htmlContent || '',
          initialHtmlContent: initialHtmlContent || '',
          numberWords: redactionData?.numberWords ?? 0,

          axeRedaction: redactionData?.axeRedaction ?? '',
          retranscription: redactionData?.retranscription ?? '',
          internalLinking: redactionData?.internalLinking ?? '',
          contentScore:
            contentScore ??
            redactionData?.contentScore ??
            redactionData?.initialScoreData ??
            null,
        };

        const response = await axiosPrivate.put(
          `/texts/external/auto-save/${currentTextId}`,
          payload
        );

        return response.data;
      } catch (error) {
        console.error('Erreur lors de l\'auto-sauvegarde:', error);
      }
    },
    [textId, user?.role]
  );

  return {
    autoSave,
  };
};
